import React from "react";
import { Navigate } from "react-router-dom";
import { ACCOUNT_MANAGEMENT } from "@consts";
import { HyroLoader } from "@hyro-components";
import AccountSettingsContent from "./AccountSettingsContent";
import useAccountSettings from "./AccountSettings.hook";

const AccountSettings = () => {
  const {
    managementAccounts,
    accountRow,
    accountData,
    isSaving,
    isConfirmationOpen,
    saveVersion,
    error,
    errorText,
    setError,
    searchParams,
    handleSubmit,
    handleDiscard,
    openConfirmation,
    closeConfirmation
  } = useAccountSettings();

  if (!managementAccounts) {
    return <HyroLoader />;
  }

  if (managementAccounts && !accountRow) {
    return <Navigate to={`/admin/${ACCOUNT_MANAGEMENT}`} replace />;
  }

  return (
    <AccountSettingsContent
      key={saveVersion}
      accountData={accountData}
      isSaving={isSaving}
      isConfirmationOpen={isConfirmationOpen}
      onSave={openConfirmation}
      onSubmit={handleSubmit}
      onConfirmationClose={closeConfirmation}
      onDiscard={handleDiscard}
      error={error}
      errorText={errorText}
      setError={setError}
      searchParams={searchParams}
    />
  );
};

export default AccountSettings;
